import * as React from 'react'
import MedalIcon from '../../../../assets/medal.png'
import { EmojiEvents } from '@mui/icons-material'
import { Popover, Box } from '@mui/material'
import { StyledIconButton, StyledImg, StyledP } from './styles'

export default function PopperPopupState() {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  function scrollToBottom() {
    window.scroll(0, document.body.scrollHeight)
  }
  const open = Boolean(anchorEl)
  return (
    <div style={{}}>
      <StyledIconButton
        onClick={scrollToBottom}
        color="warning"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <EmojiEvents
          style={{
            fontSize: '2.2rem',
            fill: 'orange'
          }}
        />
      </StyledIconButton>

      <Popover
        disableScrollLock={true}
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none'
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box
          sx={{
            p: 1,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <StyledImg src={MedalIcon} />
          <div>
            <StyledP> Parabéns, meta de páginas alcançada!!!</StyledP>
          </div>
        </Box>
      </Popover>
    </div>
  )
}
